import { definePreset, palette } from '@primeng/themes';
import Aura from '@primeng/themes/aura';

const redPalette = palette('#DD1E11');

const FastRocketPreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: redPalette[0],
      100: redPalette[1],
      200: redPalette[2],
      300: redPalette[3],
      400: redPalette[4],
      500: redPalette[5],
      600: redPalette[6],
      700: redPalette[7],
      800: redPalette[8],
      900: redPalette[9],
      950: redPalette[10]
    },
    colorScheme: {
      light: {
        primary: {
          color: '{primary.950}',
          inverseColor: '#ffffff',
          hoverColor: '{primary.900}',
          activeColor: '{primary.800}'
        },
        highlight: {
          background: '{primary.950}',
          focusBackground: '{primary.700}',
          color: '#ffffff',
          focusColor: '#ffffff'
        }
      },
      dark: {
        primary: {
          color: '{primary.50}',
          inverseColor: '{primary.950}',
          hoverColor: '{primary.100}',
          activeColor: '{primary.200}'
        },
        highlight: {
          background: 'rgba(250, 250, 250, .16)',
          focusBackground: 'rgba(250, 250, 250, .24)',
          color: 'rgba(255,255,255,.87)',
          focusColor: 'rgba(255,255,255,.87)'
        }
      }
    }
  }
});

export default FastRocketPreset;
